import type { ExperimentDto, ExperimentDtoResponse } from './dto';
import type { Experiment } from './model/Experiment';

function mapExperimentDtoToModel(item: ExperimentDto): Experiment {
  return {
    experimentId: item.experiment_id,
    containerId: item.container_id,
    variants:
      item.variants != null
        ? item.variants.map((variant) => {
            return {
              id: variant.id,
            };
          })
        : [],
  };
}

export function mapDtoToModel(
  dto: ExperimentDtoResponse,
  experimentType: 'googleExperiment' | 'optimizelyExperiment' | 'unbounceExperiment',
): Experiment[] {
  if (experimentType === 'googleExperiment' && dto.go) {
    return dto.go.map(mapExperimentDtoToModel);
  }
  if (experimentType === 'optimizelyExperiment' && dto.opt) {
    return dto.opt.map(mapExperimentDtoToModel);
  }
  if (experimentType === 'unbounceExperiment' && dto.ub) {
    return dto.ub.map(mapExperimentDtoToModel);
  }
  return [];
}
